document.addEventListener('DOMContentLoaded', function () {
  const audio = document.getElementById('vetta-music');
  const button = document.getElementById('vetta-music-button');

  if (!audio || !button) return;

  button.addEventListener('click', function () {
    if (audio.paused) {
      audio.play();
      button.classList.add('playing');
      button.innerHTML = '❚❚';
    } else {
      audio.pause();
      button.classList.remove('playing');
      button.innerHTML = '♪';
    }
  });
});